module.exports = __webpack_public_path__ + "img/JourneyCategoryScreenshot-1250h.e3f7d2e1.png";